<!-- Header Start -->
<header>
  <div class="brand">
    <a href="#">
      <img src="assets/images/brand-img.png" alt="" />
    </a>
  </div>
  <!-- <a [routerLink]="ROUTES.INBOUND">X</a> -->
  <a [routerLink]="ROUTES.CONSIGNMENT_RECALL"><img src="assets/images/edi-close.png" /></a>
</header>